import { Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import OrderWorkunit from 'types/entities/OrderWorkunit';

const DeliveryManagerCell = React.memo((row: OrderWorkunit) => {
  const [t] = useTranslation();

  return (
    <Typography variant="body2" noWrap>
      {t(row.delivery_manager_fullname)}
    </Typography>
  );
});

export default DeliveryManagerCell;
